import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=5dc8636b&scoped=true"
import script from "./Recipients.vue?vue&type=script&lang=js"
export * from "./Recipients.vue?vue&type=script&lang=js"
import style0 from "./Recipients.vue?vue&type=style&index=0&id=5dc8636b&prod&lang=scss"
import style1 from "./Recipients.vue?vue&type=style&index=1&id=5dc8636b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8636b",
  null
  
)

export default component.exports